export default __webpack_public_path__ + "static/media/component2.3d05bd71.png";